import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReviewDto } from '@checkfront/guest-experience-api-api-client-javascript-axios';
import { styled } from '@mui/material/styles';
import { classes } from '@guest-widgets/shared/src/classes';

import { RatingCategories } from './RatingCategories';
import { ReviewContent } from './ReviewContent';

export interface ReviewListProps {
  reviews: ReviewDto[];
  areCategoriesInOneRow?: boolean;
}

export const ReviewList = ({ reviews, areCategoriesInOneRow }: ReviewListProps) => (
  <div className={classes.details.reviews.list}>
    {reviews.map(({ votes, title, author, createdAt, replies, content }, index) => (
      <BorderBox key={index} className={classes.details.reviews.review.root}>
        <Box mb={2}>
          <RatingCategories votes={votes} isStacked={!areCategoriesInOneRow} />
        </Box>
        <Typography
          className={classes.details.reviews.review.header}
          variant="h5"
          component="h4"
          gutterBottom
        >
          {title}
        </Typography>
        <ReviewContent author={author.name} createdAt={createdAt} content={content} />
        {replies.length > 0 && (
          <Box className={classes.details.reviews.review.replies} ml={2} mt={2}>
            {replies.map((reply) => (
              <ReviewContent
                key={reply.createdAt}
                author={reply.author.name}
                createdAt={reply.createdAt}
                content={reply.content}
              />
            ))}
          </Box>
        )}
      </BorderBox>
    ))}
  </div>
);

const BorderBox = styled('div')(({ theme: { spacing, border, shape, palette } }) => ({
  '&:not(:last-child)': {
    marginBottom: spacing(3),
  },
  border: border,
  borderRadius: shape.borderRadius,
  padding: spacing(3, 4),
  backgroundColor: palette.background.default,
}));
